/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PurchaseMissionMarkUpRecordDto model module.
 * @module model/PurchaseMissionMarkUpRecordDto
 * @version v1.0.0
 */
class PurchaseMissionMarkUpRecordDto {
    /**
     * Constructs a new <code>PurchaseMissionMarkUpRecordDto</code>.
     * @alias module:model/PurchaseMissionMarkUpRecordDto
     */
    constructor() { 
        
        PurchaseMissionMarkUpRecordDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PurchaseMissionMarkUpRecordDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PurchaseMissionMarkUpRecordDto} obj Optional instance to populate.
     * @return {module:model/PurchaseMissionMarkUpRecordDto} The populated <code>PurchaseMissionMarkUpRecordDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PurchaseMissionMarkUpRecordDto();

            if (data.hasOwnProperty('markUp')) {
                obj['markUp'] = ApiClient.convertToType(data['markUp'], 'Number');
            }
            if (data.hasOwnProperty('time')) {
                obj['time'] = ApiClient.convertToType(data['time'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * mark up
 * @member {Number} markUp
 */
PurchaseMissionMarkUpRecordDto.prototype['markUp'] = undefined;

/**
 * time
 * @member {Number} time
 */
PurchaseMissionMarkUpRecordDto.prototype['time'] = undefined;






export default PurchaseMissionMarkUpRecordDto;

